import PostReportModal from './PostReportModal';

export default PostReportModal;
